<template>
    <div class="container">
        <div class="pageTitle">发布公告</div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="公告分类:" prop="category_id1">
                <el-col :span="3" v-if="!cateLevelOneName">
                    <el-select clearable v-model="form.category_id1" placeholder="请选择一级分类" @change="selectCateOne">
                        <el-option v-for=" i in categoryOne" :key="i.id" :label="i.name"
                                   :value="i.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="1" style="text-align: center">-</el-col>
                <el-col :span="3" v-if="!cateLevelOneName">
                    <el-select clearable v-model="form.category_id2" placeholder="请选择二级分类" >
                        <el-option v-for=" i in categoryTwo" :key="i.id" :label="i.name"
                                   :value="i.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="2" v-if="cateLevelOneName">
                    {{cateLevelOneName}} > {{cateLevelTwoName}}
                    <span class="fa  fa-pencil" style="color: black;cursor: pointer;margin-left: 10px" @click="selectCate()"></span>
                </el-col>
                <el-button style="margin: 0 20px;" @click="refresh()">刷新</el-button>
                <router-link to='./announcementCate'  style="color: blue;cursor: pointer">添加分类</router-link>
              <!--  <span style="color: blue;cursor: pointer" @click="addCate()">添加分类</span>-->
            </el-form-item>
            <el-form-item label="公告标题:" prop="title">
                <el-col :span="8">
                    <el-input v-model="form.title"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="公告内容:" prop="content">
                <el-col :span="12">
                     <quill-editor ref="myTextEditor"
                                   v-model="form.content" :options="quillOption">
                     </quill-editor>
                </el-col>
            </el-form-item>
            <el-form-item label="排序:" prop="sort">
                <el-col :span="2">
                    <el-input type="number" v-model="form.sort"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="备注:" prop="">
                <el-col :span="8">
                    <el-input type="textarea" v-model="form.remarks"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="发布对象:" prop="">
                <el-col :span="24">
                    <el-checkbox v-model="typeChecked">指定角色类型发布</el-checkbox>
                </el-col>
                <el-row v-if="typeChecked">
                    <el-col :span="8">
                        <div class="typeBox">
                            <div class="pageTitle">提示：选择了的角色类型中包含的所有人员都能看到该公告</div>
                            <el-form ref="formType" :model="formType" label-width="40px" class="mt20">
                                <el-form-item label="">
                                    <el-col :span="8">
                                        <el-checkbox v-model="dealerDirect">直属经销商</el-checkbox>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-checkbox v-model="dealerNotDirect">非直属经销商</el-checkbox>
                                    </el-col>
                                </el-form-item>
                               <!-- <el-form-item label="">
                                    <el-col :span="8">
                                        <el-checkbox v-model="storeDirect">直属门店</el-checkbox>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-checkbox v-model="storeNotDirect">非直属门店</el-checkbox>
                                    </el-col>
                                </el-form-item>
                                <el-form-item label="" v-for="item in staffType ">
                                    <el-col :span="8">
                                        <el-checkbox v-model="item.isChecked">{{item.type_name}}</el-checkbox>
                                    </el-col>
                                </el-form-item>-->
                            </el-form>

                        </div>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="" prop="">
                <el-col :span="24">
                    <el-checkbox v-model="memberChecked">指定人员发布</el-checkbox>
                </el-col>
                <el-row v-if="memberChecked">
                    <el-col :span="16">
                        <div class="memberType">
                            <div class="pageTitle">提示：只有选择了的人员才能看到该公告
                                <el-tabs v-model="activeName" type="card" @tab-click="handleClick"
                                         style="margin: 20px 0">
                                    <el-tab-pane label="经销商" name="first">
                                        <el-button type="primary" style="margin-bottom: 10px"
                                                   @click="addDealer()">添加经销商
                                        </el-button>
                                        <el-table
                                                :data="tableData1"
                                                height="250"
                                                border
                                                @selection-change="handleSelectionChangeDealer"
                                                style="width: 100%">
                                            <el-table-column
                                                    type="selection"
                                                    width="55">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="dealer_sn"
                                                    label="经销商编号"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="dealer_name"
                                                    label="经销商名称"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="mobile"
                                                    label="手机号">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="person"
                                                    label="负责人">
                                            </el-table-column>
                                            <el-table-column
                                                    label="操作">
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="small"
                                                               @click="dealerDel(scope.$index,scope.row.dealer_sn)">删除
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-pagination
                                                v-if="notice_id"
                                                @size-change="handleSizeChange1"
                                                @current-change="handleCurrentChange1"
                                                :current-page="pageNo1"
                                                :page-sizes="[20, 50, 100, 200]"
                                                :page-size="pageSize1"
                                                layout="total, sizes, prev, pager, next, jumper"
                                                :total="totalSize1">
                                        </el-pagination>
                                        <el-button type="primary" style="margin: 10px 0" @click="delDealerMulti()">
                                            批量删除
                                        </el-button>
                                        <!--分页-->

                                    </el-tab-pane>
                                   <!-- <el-tab-pane label="门店" name="second">
                                        <el-button type="primary" style="margin-bottom: 10px"
                                                   @click="addStore()">添加门店
                                        </el-button>
                                        <el-table
                                                :data="tableData2"
                                                height="250"
                                                border
                                                @selection-change="handleSelectionChangeStore"
                                                style="width: 100%">
                                            <el-table-column
                                                    type="selection"
                                                    width="55">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="shop_sn"
                                                    label="门店编号"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="shop_name"
                                                    label="门店名称"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="address"
                                                    label="门店地址">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="mobile"
                                                    label="手机号">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="person"
                                                    label="负责人">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="isself"
                                                    label="类型">
                                            </el-table-column>
                                            <el-table-column
                                                    prop=""
                                                    label="操作">
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="small" @click="storeDel(scope.$index,scope.row.shop_sn)">
                                                        删除
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-pagination
                                                v-if="notice_id"
                                                @size-change="handleSizeChange2"
                                                @current-change="handleCurrentChange2"
                                                :current-page="pageNo2"
                                                :page-sizes="[20, 50, 100, 200]"
                                                :page-size="pageSize2"
                                                layout="total, sizes, prev, pager, next, jumper"
                                                :total="totalSize2">
                                        </el-pagination>
                                        <el-button type="primary" style="margin: 10px 0" @click="delStoreMulti()">批量删除
                                        </el-button>
                                    </el-tab-pane>
                                    <el-tab-pane label="员工" name="third">
                                        <el-button type="primary" style="margin-bottom: 10px"
                                                   @click="addWorker()">添加员工
                                        </el-button>
                                        <el-table
                                                :data="tableData3"
                                                height="250"
                                                border
                                                @selection-change="handleSelectionChangeWorker"
                                                style="width: 100%">
                                            <el-table-column
                                                    type="selection"
                                                    width="55">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="staff_sn"
                                                    label="员工编号"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="staff_name"
                                                    label="员工姓名"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="mobile"
                                                    label="手机号">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="region"
                                                    label="管理范围">
                                                <template slot-scope="scope">
                                                    <span v-for="item in scope.row.region">{{item}}&nbsp;&nbsp;</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="type_name"
                                                    label="类型">
                                            </el-table-column>
                                            <el-table-column
                                                    prop=""
                                                    label="操作">
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="small" @click="workerDel(scope.$index,scope.row.staff_sn)">删除</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-pagination
                                                v-if="notice_id"
                                                @size-change="handleSizeChange3"
                                                @current-change="handleCurrentChange3"
                                                :current-page="pageNo3"
                                                :page-sizes="[20, 50, 100, 200]"
                                                :page-size="pageSize3"
                                                layout="total, sizes, prev, pager, next, jumper"
                                                :total="totalSize3">
                                        </el-pagination>
                                        <el-button type="primary" style="margin: 10px 0" @click="delWorkerMulyi()">批量删除</el-button>
                                    </el-tab-pane>-->
                                </el-tabs>
                            </div>
                        </div>

                    </el-col>
                </el-row>

            </el-form-item>
            <el-form-item>
                <el-col :span="8">
                    <el-button type="primary" @click="save('form')">保存</el-button>
                </el-col>
            </el-form-item>
        </el-form>

        <cateDialog
                v-if="cateDialogVisable"
                v-on:handleClose='cateDialogVisable = false'
                @pushData="getCateInfo">

        </cateDialog>
        <addDealer v-if="addDealerVisable"
                   v-on:handleClose='addDealerVisable = false'
                   :pushData="tableData1"
                   :type="type"
                   :notice_id="notice_id"
                   :source="source"
                   @submit="getDealerInfo"
                   @onSearch="getDetails"
                   @refresh="getEditDealer">
        </addDealer>
        <addStore
                v-if="addStoreVisable"
                v-on:handleClose='addStoreVisable = false'
                :type="type"
                :source="source"
                :notice_id="notice_id"
                :pushData="tableData2"
                @submit="getStoreInfo"
                @onSearch="getDetails"
                @refresh="getEditStore">


        </addStore>
        <addWorker
                v-if="addWorkerVisable"
                v-on:handleClose='addWorkerVisable = false'
                :type="type"
                :source="source"
                :notice_id="notice_id"
                :pushData="tableData3"
                @submit="getWorkerInfo"
                @onSearch="getDetails"
                @refresh="getEditWorker">

        </addWorker>
    </div>
</template>

<script>
    import cateDialog from '@/common/cateDialog';
    import addDealer from '@/common/addDealer';
    import addStore from '@/common/addStore';
    import addWorker from '@/common/addWorker';
    const validateAcquaintance = (rule, value, callback) => {
        if (!value) {
            callback(new Error('必须输入排序'))
        }
        value = Number(value)
        if (typeof value === 'number' && !isNaN(value)) {
            if (value < 0 || value > 1000) {
                callback(new Error('排序在 0 至 1000 之间'))
            } else {
                callback()
            }
        } else {
            callback(new Error('排序必须为数字'))
        }
    }
    /*const uploadConfig = {
        action:  'http://lloa.c.qiema.cc/admin/v1/uploads/images',  // 必填参数 图片上传地址
        methods: 'POST',  // 必填参数 图片上传方式
        token: '',  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        name: 'images[]',  // 必填参数 文件的参数名
        size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon'  // 可选 可上传的图片格式
    };*/
    export default {
        name: "release-announcement",

        data() {
            return {
                source:'公告',//弹窗内区别是文件还是公告，公用
                cateDialogVisable: false,
                addDealerVisable: false,
                addStoreVisable: false,
                addWorkerVisable: false,
                form: {
                    title:'',
                    sort:0,
                    remarks:'',
                    category_id1:'',
                    category_id2:'',
                    content: '',
                },
                formType: {},
                typeChecked: '',
                memberChecked: '',
                dealerDirect: '',
                dealerDirect: '',
                dealerNotDirect: '',
                storeDirect: '',
                storeNotDirect: '',
                areaManager: '',
                salesman: '',
                customType: '',
                activeName: 'first',
                tableData1: [],
                multipleSelectionDealer: [],
                //分页
                pageNo1: 1,
                pageSize1: 20,
                totalSize1: 0,
                tableData2: [],
                multipleSelectionStore: [],
                //分页
                pageNo2: 1,
                pageSize2: 20,
                totalSize2: 0,
                tableData3: [],
                multipleSelectionWorker: [],
                pageNo3: 1,
                pageSize3: 20,
                totalSize3: 0,
                rules: {
                    title: [
                        { required: true, message: '请填写公告标题', trigger: 'blur' }
                    ],
                    category_id1: [
                        { required: true, message: '请选择分类', trigger: 'change' }
                    ],
                    sort: [
                        /*{
                            required: true,
                            message: '请输入排序',
                            trigger: 'blur'
                        }, {
                            type: 'number',
                            message: '排序必须为数字',
                            trigger: 'blur'
                        },*/
                        {
                            required: true,
                            message: '请输入排序',
                        },
                        {
                            validator: validateAcquaintance, // 自定义验证
                            trigger: 'blur'
                        }
                    ],
                    content:[
                        {
                            required: true, message: '请填写公告内容', trigger: 'blur'
                        }
                    ]
                },
               /* content: '</br></br></br></br></br></br></br></br></br>',*/
                editorOption: {},
                /*quillOption: quillConfig,*/
                quillOption: {
                    placeholder: '',
                    theme: 'snow',  // 主题
                    modules: {
                        toolbar: {
                            container: [
                                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                                [{'header': 1}, {'header': 2}],               // custom button values
                                [{'list': 'ordered'}, {'list': 'bullet'}],
                                [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
                                [{'direction': 'rtl'}],                         // text direction
                                [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
                                [{'header': [1, 2, 3, 4, 5, 6, false]}],
                                [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                                [{'font': []}],
                                [{'align': []}],
                                ['image'],
                                ['clean']
                            ],  // 工具栏选项
                            handlers: {
                                image: function image() {
                                    var self = this;
                                    var fileInput = this.container.querySelector('input.ql-image[type=file]');
                                    if (fileInput === null) {
                                        fileInput = document.createElement('input');
                                        fileInput.setAttribute('type', 'file');
                                        // 设置图片参数名
                                       /* if (uploadConfig.name) {
                                            fileInput.setAttribute('name', 'images[]');
                                        }*/
                                        // 可设置上传图片的格式
                                        let type = 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',serveUrl = '';
                                        if(process.env.NODE_ENV == 'development'){
                                            serveUrl = 'http://lloa.c.qiema.cc/admin/v1/uploads/images';
                                        }else if(process.env.NODE_ENV == 'production'){
                                            serveUrl = 'http://lloa.api.qiema.cn/admin/v1/uploads/images';
                                        }else{
                                            serveUrl = 'http://lloa.c.qiema.cc/admin/v1/uploads/images';
                                        }
                                        fileInput.setAttribute('accept', type);
                                        fileInput.classList.add('ql-image');
                                        // 监听选择文件
                                        fileInput.addEventListener('change', function () {
                                            // 创建formData
                                            var formData = new FormData();
                                            formData.append('images[]', fileInput.files[0]);
                                            // 图片上传
                                            var xhr = new XMLHttpRequest();
                                            xhr.open('POST', serveUrl, true);
                                            xhr.setRequestHeader('Authorization','Bearer' + " " + localStorage.getItem('access_token'));
                                            // 上传数据成功，会触发
                                            xhr.onload = function (e) {
                                                if (xhr.status === 200) {
                                                    var res = JSON.parse(xhr.responseText);
                                                    let length = self.quill.getSelection(true).index;
                                                    //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
                                                    self.quill.insertEmbed(length, 'image', res.data[0].full_url);
                                                    self.quill.setSelection(length + 1);
                                                }
                                                fileInput.value = ''
                                            };
                                            // 开始上传数据
                                            xhr.upload.onloadstart = function (e) {
                                                fileInput.value = ''
                                            };
                                            // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
                                            xhr.upload.onerror = function (e) {
                                            };
                                            // 上传数据完成（成功或者失败）时会触发
                                            xhr.upload.onloadend = function (e) {
                                                // console.log('上传结束')
                                                console.log(e);
                                            };
                                            xhr.send(formData);
                                        });
                                        this.container.appendChild(fileInput);
                                    }
                                    fileInput.click();
                                }
                            }
                        }
                    }
                },
                cateLevelOneName:'',
                cateLevelTwoName:'',
                categoryOne:[],
                categoryTwo:[],
                staffType:[],
                type:0,//默认2为编辑，1为新增
                notice_id:'',//传到子组件
                /*编辑的时候保存sn*/
                dealer_list:[],
                shop_list:[],
                staff_list:[]
                /**/

            }
        },
        methods: {
            //获取员工类型
            getStaffType(){
                this.$get('logistics' , '/staffs.types', {
                    per_page:10000,
                    page:1
                }).then(res => {
                    if(res.data.length){
                        for (var i = 0; i < res.data.length; i++) {
                            res.data[i].isChecked = false;
                        }
                    }
                    this.staffType = res.data;
                    if(this.$route.query.notice_id){
                        this.getDetails();
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            // 获取分类
            getCataOne(){
                this.$get('logistics' ,'/categories.one', {
                    lang:'',
                    type:1
                }).then(res => {
                    this.categoryOne = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //选择一级分类
            selectCateOne(val){
                this.form.category_id1 = val;
                this.categoryTwo = [];
                this.form.category_id2 = '';
                this.getCateTwo();
            },
            getCateTwo(){
                this.$get('logistics' ,'/categories.two', {
                    lang:'',
                    type:1,
                    pid:this.form.category_id1
                }).then(res => {
                    this.categoryTwo = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            refresh(){
                this.getCataOne();
                this.form.category_id1 = '';
                this.form.category_id2 = '';
            },
            //获取的选择分类信息
            getCateInfo(val){
                this.cateLevelOneName = val.label1;
                this.cateLevelTwoName = val.label2;
            },
            //选择分类
            selectCate() {
                this.cateDialogVisable = true;
            },
            //获取经销商信息
            getDealerInfo(val) {
                if (val.length && val.length >= 1) {
                    for (var i = 0; i < val.length; i++) {
                        this.tableData1.push(val[i])
                    }
                } else {
                    this.tableData1.push(val);
                }
            },
            //获取门店信息
            getStoreInfo(val) {
                if (val.length && val.length >= 1) {
                    for (var i = 0; i < val.length; i++) {
                        this.tableData2.push(val[i])
                    }
                } else {
                    this.tableData2.push(val);
                }
            },
            //获取员工信息
            getWorkerInfo(val) {
                console.log(val);
                if (val.length && val.length >= 1) {
                    for (var i = 0; i < val.length; i++) {
                        this.tableData3.push(val[i])
                    }
                } else {
                    this.tableData3.push(val);
                }
            },
            //经销商删除
            dealerDel(index,dealer_sn) {
                if(this.$route.query.notice_id){
                    let url = '/notices/' + this.notice_id +'/designee',snArr = [];
                    snArr.push(dealer_sn);
                    this.$post('logistics' , url, {
                        lang:'',
                        notice:this.notice_id,
                        _method:'DELETE',
                        designee_type:1,
                        designee_sns:snArr
                    }).then(res => {
                        this.getDetails();
                        this.getEditDealer();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                    return;
                }
                this.tableData1.splice(index, 1);
            },
            //经销商批量删除
            delDealerMulti() {
                if(this.multipleSelectionDealer.length == 0){
                    this.$message.error('请勾选数据...');
                    return;
                }
                if(this.$route.query.notice_id){
                    let url = '/notices/' + this.notice_id +'/designee',snArr = [];
                    for(var i = 0; i < this.multipleSelectionDealer.length;i++){
                        snArr.push(this.multipleSelectionDealer[i].dealer_sn);
                    }
                    this.$post('logistics' , url, {
                        lang:'',
                        notice:this.notice_id,
                        _method:'DELETE',
                        designee_type:1,
                        designee_sns:snArr
                    }).then(res => {
                        this.getDetails();
                        this.getEditDealer();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                    return;
                }
                this.arrayRiff(this.tableData1, this.multipleSelectionDealer);
            },
            handleSelectionChangeDealer(val) {
                this.multipleSelectionDealer = val;
            },
            //门店删除
            storeDel(index,shop_sn) {
                if(this.$route.query.notice_id){
                    let url = '/notices/' + this.notice_id +'/designee',snArr = [];
                    snArr.push(shop_sn);
                    this.$post('logistics' ,url, {
                        lang:'',
                        notice:this.notice_id,
                        _method:'DELETE',
                        designee_type:2,
                        designee_sns:snArr
                    }).then(res => {

                        this.getDetails();
                        this.getEditStore();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                    return;
                }
                this.tableData2.splice(index, 1);
            },
            //门店批量删除
            handleSelectionChangeStore(val) {

                this.multipleSelectionStore = val;
            },
            delStoreMulti() {
                if(this.multipleSelectionStore.length == 0){
                    this.$message.error('请勾选数据...');
                    return;
                }
                if(this.$route.query.notice_id){
                    let url = '/notices/' + this.notice_id +'/designee',snArr = [];
                    for(var i = 0; i < this.multipleSelectionStore.length;i++){
                        snArr.push(this.multipleSelectionStore[i].shop_sn);
                    }
                    this.$post('logistics' , url, {
                        lang:'',
                        notice:this.notice_id,
                        _method:'DELETE',
                        designee_type:2,
                        designee_sns:snArr
                    }).then(res => {
                        this.getDetails();
                        this.getEditStore();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                    return;
                }
                this.arrayRiff(this.tableData2, this.multipleSelectionStore);
            },
            //员工删除
            workerDel(index,staff_sn){
                if(this.$route.query.notice_id){
                    let url = '/notices/' + this.notice_id +'/designee',snArr = [];
                    snArr.push(staff_sn);
                    this.$post('logistics' , url, {
                        lang:'',
                        notice:this.notice_id,
                        _method:'DELETE',
                        designee_type:3,
                        designee_sns:snArr
                    }).then(res => {

                        this.getDetails();
                        this.getEditWorker();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                    return;
                }


                this.tableData3.splice(index, 1);
            },
            //员工批量删除
            handleSelectionChangeWorker(val){
                this.multipleSelectionWorker = val;
            },
            delWorkerMulyi(){
                if(this.multipleSelectionWorker.length == 0){
                    this.$message.error('请勾选数据...');
                    return;
                }
                if(this.$route.query.notice_id){
                    let url = '/notices/' + this.notice_id +'/designee',snArr = [];
                    for(var i = 0; i < this.multipleSelectionDealer.length;i++){
                        snArr.push(this.multipleSelectionDealer[i].staff_sn);
                    }
                    this.$post('logistics' , url, {
                        lang:'',
                        notice:this.notice_id,
                        _method:'DELETE',
                        designee_type:3,
                        designee_sns:snArr
                    }).then(res => {
                        this.getDetails();
                        this.getEditWorker();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                    return;
                }
                this.arrayRiff(this.tableData3, this.multipleSelectionWorker);
            },
            //数组删除(比较重复删除)
            arrayRiff(a, b) {
                for (var i = 0; i < b.length; i++) {
                    for (var j = 0; j < a.length; j++) {
                        if (a[j].id == b[i].id) {
                            a.splice(j, 1);
                            j = j - 1;
                        }
                    }
                }
                return a;
            },
            arrayRiffCheckbox(a, b) {
                for (var i = 0; i < b.length; i++) {
                    for (var j = 0; j < a.length; j++) {
                        if (a[j].id == b[i] - 0) {
                            a[j].isChecked = true;
                        }
                    }
                }
                return a;
            },
            //保存提交
            save(formName){
                if(this.typeChecked){
                    if(!this.dealerDirect && !this.dealerNotDirect){
                        this.$message({
                            type: 'error',
                            message: '请选择指定角色类型。。'
                        });
                        return;
                    }
                }
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            if(this.notice_id){
                                let cateId = '',dealer_list= [],shop_list =[],staff_list =[];
                                if(this.form.category_id2){
                                    cateId =this.form.category_id2;
                                }else{
                                    cateId = this.form.category_id1 || '';
                                }
                                //处理数组
                                for(var i = 0; i < this.tableData1.length;i++){
                                    dealer_list.push(this.tableData1[i].dealer_sn);
                                }
                                for(var i = 0; i < this.tableData2.length;i++){
                                    shop_list.push(this.tableData2[i].shop_sn);
                                }
                                for(var i = 0; i < this.tableData3.length;i++){
                                    staff_list.push(this.tableData3[i].staff_sn);
                                }
                                let staffIDArr = [];
                                for(var i =0; i < this.staffType.length;i++){
                                    if(this.staffType[i].isChecked){
                                        staffIDArr.push(this.staffType[i].id);
                                    }
                                }
                                this.$put('logistics' , '/notices/' + this.notice_id, {
                                    lang:'',
                                    _method:'PUT',
                                    category_id:cateId,
                                    title:this.form.title,
                                    content:this.form.content,
                                    sort:this.form.sort,
                                    remarks:this.form.remarks,
                                    role_push:this.fomateChecked(this.typeChecked),
                                    dealer_directly:this.fomateChecked(this.dealerDirect),
                                    dealer_not_directly:this.fomateChecked(this.dealerNotDirect),
                                    shop_directly:this.fomateChecked(this.storeDirect),
                                    shop_not_directly:this.fomateChecked(this.storeNotDirect),
                                    staff_types:staffIDArr,
                                    detail_push:this.fomateChecked(this.memberChecked),
                                    dealer_list:dealer_list,
                                    shop_list:shop_list,
                                    staff_list:staff_list
                                }).then(res => {
                                    this.$message({
                                        type: 'success',
                                        message: '修改成功'
                                    });
                                    this.$router.push({name:'announcementList'});
                                }).catch(error =>{
                                    this.$message({
                                        type: 'error',
                                        message: error.message
                                    });

                                });
                                return;
                            }
                            let cateId = '',dealer_list= [],shop_list =[],staff_list =[];
                            if(this.form.category_id2){
                                cateId =this.form.category_id2;
                            }else{
                                cateId = this.form.category_id1 || '';
                            }
                           if(this.memberChecked && this.tableData1.length == 0){
                               this.$message({
                                   type: 'error',
                                   message: '请选择经销商。。'
                               });
                               return;
                           }
                            //处理数组
                            for(var i = 0; i < this.tableData1.length;i++){
                                dealer_list.push(this.tableData1[i].dealer_sn);
                            }
                            for(var i = 0; i < this.tableData2.length;i++){
                                shop_list.push(this.tableData2[i].shop_sn);
                            }
                            for(var i = 0; i < this.tableData3.length;i++){
                                staff_list.push(this.tableData3[i].staff_sn);
                            }
                            let staffArr = [];
                            for(var i =0; i < this.staffType.length;i++){
                                if(this.staffType[i].isChecked){
                                    staffArr.push(this.staffType[i].id);
                                }
                            }
                            this.$post('logistics',  '/notices', {
                                lang:'',
                                category_id:cateId,
                                title:this.form.title,
                                content:this.form.content,
                                sort:this.form.sort,
                                remarks:this.form.remarks,
                                role_push:this.fomateChecked(this.typeChecked),
                                dealer_directly:this.fomateChecked(this.dealerDirect),
                                dealer_not_directly:this.fomateChecked(this.dealerNotDirect),
                                shop_directly:this.fomateChecked(this.storeDirect),
                                shop_not_directly:this.fomateChecked(this.storeNotDirect),
                                staff_types:staffArr,
                                detail_push:this.fomateChecked(this.memberChecked),
                                dealer_list:dealer_list,
                                shop_list:shop_list,
                                staff_list:staff_list
                            }).then(res => {
                                this.$message({
                                    type: 'success',
                                    message: '发布成功'
                                });
                                this.$router.push({name:'announcementList'});
                            }).catch(error =>{
                                this.$message({
                                    type: 'error',
                                    message: error.message
                                });

                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });


            },
            fomateChecked(val){
                if(val){
                    return 1
                }else{
                    return 0
                }

            },
            formatDetail(val){
                if(val == 1){
                    return true
                }else{
                    return false
                }
            },
            //添加经销商
            addDealer(){
                if(this.$route.query.notice_id){
                    this.type = 2;
                    this.addDealerVisable = true;
                    return;
                }
                this.type = 1;
                this.addDealerVisable = true;
            },
            //添加门店
            addStore(){
                if(this.$route.query.notice_id){
                    this.type = 2;
                    this.addStoreVisable = true;
                    return;
                }
                this.type = 1;
                this.addStoreVisable = true;
            },
            //添加店员
            addWorker(){
                if(this.$route.query.notice_id){
                    this.type = 2;
                    this.addWorkerVisable = true;
                    return;
                }
                this.type = 1;
                this.addWorkerVisable = true;
            },
            //编辑的时候批量获取经销商
            getEditDealer(){
                this.$post('logistics', '/dealers.batchs', {
                    lang:'',
                    per_page:this.pageSize1,
                    page:this.pageNo1,
                    dealer_sns:this.dealer_list.join(',')
                }).then(res => {
                   this.tableData1 = res.data;
                   if(res.data.length == 0){
                       this.totalSize1 = 0;
                       return;
                   }
                    this.totalSize1 = res.meta.total;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //编辑的时候获取门店
          /*  getEditStore(){
                this.$post(this.global + '/shops.batchs', {
                    lang:'',
                    per_page:this.pageSize2,
                    page:this.pageNo2,
                    shop_sns:this.shop_list.join(',')
                }).then(res => {
                    this.tableData2 = res.data;
                    this.totalSize2 = res.meta.total;
                }).catch(function (error) {
                    console.log(error);
                });
            },*/
            //编辑的时候获取员工
           /* getEditWorker(){
                this.$post(this.global + '/staffs.batchs', {
                    lang:'',
                    per_page:this.pageSize3,
                    page:this.pageNo3,
                    staff_sns:this.staff_list.join(',')
                }).then(res => {
                    this.tableData3 = res.data;
                    this.totalSize3 = res.meta.total;
                }).catch(function (error) {
                    console.log(error);
                });
            },*/
            //指定人员发布（分布）
            /*分页*/
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.pageNo1 = 1;
                this.getEditDealer();
            },
            handleCurrentChange1(val) {
                this.pageNo1 = val;
                this.getEditDealer();

            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.pageNo2 = 1;
                this.getEditStore();
            },
            handleCurrentChange2(val) {
                this.pageNo2 = val;
                this.getEditStore();

            },
            handleSizeChange3(val) {
                this.pageSize3 = val;
                this.pageNo3 = 1;
                this.getEditWorker();
            },
            handleCurrentChange3(val) {
                this.pageNo3 = val;
                this.getEditWorker();

            },
            //编辑查询详情
            getDetails(){
                if(!this.$route.query.notice_id){
                    return
                }
                this.notice_id = this.$route.query.notice_id;
                this.$get('logistics', '/notices/' + this.$route.query.notice_id, {
                    lang:'',
                    notice:this.$route.query.notice_id
                }).then(res => {
                    this.form.category_id2 = res.data.category_id;
                    this.form.category_id1 = res.data.pid;
                    this.$get('logistics',  '/categories.two', {
                        lang:'',
                        type:1,
                        pid:res.data.pid
                    }).then(res => {
                        this.categoryTwo = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                    this.form.content = res.data.content;
                    this.form.title = res.data.title;
                    this.form.remarks = res.data.remarks;
                    this.form.sort = res.data.sort;
                    this.dealer_list = res.data.config.dealer_list;
                    this.shop_list = res.data.config.shop_list;
                    this.staff_list = res.data.config.staff_list;
                    this.getEditDealer();
                    //this.getEditStore();
                    //this.getEditWorker();
                    this.typeChecked = this.formatDetail(res.data.config.role_push);
                    this.dealerDirect = this.formatDetail(res.data.config.dealer_directly);
                    this.dealerNotDirect = this.formatDetail(res.data.config.dealer_not_directly);
                    this.storeDirect = this.formatDetail(res.data.config.shop_directly);
                    this.storeNotDirect = this.formatDetail(res.data.config.shop_not_directly);
                    this.memberChecked = this.formatDetail(res.data.config.detail_push);
                    if(res.data.config.staff_types.length){
                        this.staffType = this.arrayRiffCheckbox(this.staffType,res.data.config.staff_types);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleClick(tab, event) {
            }
        },
        created() {


        },
        mounted(){
            this.$nextTick(function(){
                this.getCataOne();
                this.getStaffType();

            })
                        // this.getDetails();
            
        },
        components: {
            cateDialog, addDealer, addStore, addWorker
        }
    }
</script>

<style lang="scss" scoped>
    .typeBox {
        //height: 180px;
        border: 1px solid #ccc;
        padding: 10px;
    }

    .memberType {
        height: 500px;
        //overflow: scroll;
        border: 1px solid #ccc;
        padding: 10px;
    }

</style>